import authDe from "./authDe";
import commonDe from "./commonDe";
import footerDe from "./footerDe";
import galleryDe from "./galleryDe";
import menuDe from "./menuDe";
import navigationDe from "./navigationDe";
import orderDe from "./orderDe";
import paymentDe from "./paymentDe";
import statisticsDe from "./statisticsDe";

const mainDe = {
    common: commonDe,
    navigation: navigationDe,
    menu: menuDe,
    statistics: statisticsDe,
    order: orderDe,
    payment: paymentDe,
    auth: authDe,
    gallery: galleryDe,
    footer: footerDe,
};

export default mainDe;
